// import _ from 'lodash'
import vm from '../main'

const internals = {}

internals.addSite = function(site) {
    // Filter out properties not needed
    site = (({
        _id,
        siteName,
        siteCode,
        siteType,
        capacity,
        email,
        latitude,
        longitude,
        address,
        customerName,
        supervisor,
        ownerName,
        ownerMobile,
        ownerEmail,
        region,
        ownerAddress,
        dateAdded,
        status,
        dispenserCount,
        motherStation,
        salesManager,
        siteInfoImage,
        deviceId
    }) => {
        return {
            _id,
            siteName,
            siteCode,
            siteType,
            capacity,
            email,
            latitude,
            longitude,
            address,
            customerName,
            supervisor,
            ownerName,
            ownerMobile,
            ownerEmail,
            region,
            ownerAddress,
            dateAdded,
            status,
            dispenserCount,
            salesManager,
            motherStation,
            siteInfoImage,
            deviceId
        }
    })(site)

    return vm.$siteDataRepository
        .create(site)
        .then(result => {
            site = result.data
            return site
        })
        .catch(error => {
            console.error('siteService.createRole-error:\n', error)
            throw error
        })
}

internals.updateSite = function(site) {
    site = Object.assign({}, site)
        // Filter out properties not needed
    site = (({
        _id,
        siteName,
        siteCode,
        siteType,
        capacity,
        email,
        latitude,
        longitude,
        address,
        customerName,
        supervisor,
        ownerName,
        ownerMobile,
        ownerEmail,
        region,
        ownerAddress,
        dateAdded,
        status,
        dispenserCount,
        salesManager,
        motherStation,
        siteInfoImage,
        deviceId
    }) => {
        return {
            _id,
            siteName,
            siteCode,
            siteType,
            capacity,
            email,
            latitude,
            longitude,
            address,
            customerName,
            supervisor,
            ownerName,
            ownerMobile,
            ownerEmail,
            region,
            ownerAddress,
            dateAdded,
            status,
            dispenserCount,
            motherStation,
            salesManager,
            siteInfoImage,
            deviceId
        }
    })(site)

    return vm.$siteDataRepository
        .update(site._id, site)
        .then(result => {
            site = result.data
            return site
        })
        .catch(error => {
            console.error('siteUpdate.update-error:\n', error)
            throw error
        })
}

export default internals


// WEBPACK FOOTER //
// ./src/services/site.service.js